// src/region/index.ts
var AWS_REGIONS = {
  // US — Active
  "us-west-2": {
    name: "US West (Oregon)",
    continent: "us",
    backupRegion: "us-east-1",
    alias: "pdx",
    fullName: "Oregon",
    enabled: true
  },
  "us-east-1": {
    name: "US East (N. Virginia)",
    continent: "us",
    backupRegion: "us-west-2",
    alias: "iad",
    fullName: "Northern Virginia",
    enabled: true
  },
  // EU — Coming Soon
  "eu-central-1": {
    name: "EU (Frankfurt)",
    continent: "eu",
    backupRegion: "eu-west-1",
    alias: "fra",
    fullName: "Frankfurt",
    enabled: false
  },
  "eu-west-1": {
    name: "EU (Ireland)",
    continent: "eu",
    backupRegion: "eu-central-1",
    alias: "dub",
    fullName: "Dublin",
    enabled: false
  },
  // AP — Coming Soon
  "ap-northeast-1": {
    name: "Asia Pacific (Tokyo)",
    continent: "ap",
    backupRegion: "ap-southeast-1",
    alias: "tyo",
    fullName: "Tokyo",
    enabled: false
  },
  "ap-southeast-1": {
    name: "Asia Pacific (Singapore)",
    continent: "ap",
    backupRegion: "ap-northeast-1",
    alias: "sin",
    fullName: "Singapore",
    enabled: false
  },
  // IN — Coming Soon
  "ap-south-1": {
    name: "Asia Pacific (Mumbai)",
    continent: "in",
    backupRegion: "ap-south-2",
    alias: "bom",
    fullName: "Mumbai",
    enabled: false
  },
  "ap-south-2": {
    name: "Asia Pacific (Hyderabad)",
    continent: "in",
    backupRegion: "ap-south-1",
    alias: "hyd",
    fullName: "Hyderabad",
    enabled: false
  }
};
var AWS_CONTINENTS = {
  us: {
    label: "US - US West (Oregon) and US East (N. Virginia)",
    regions: ["us-west-2", "us-east-1"],
    enabled: true
  },
  eu: {
    label: "EU - Europe (Frankfurt) and Europe (Ireland)",
    regions: ["eu-central-1", "eu-west-1"],
    enabled: false,
    status: "Coming Soon"
  },
  ap: {
    label: "AP - Asia Pacific (Tokyo) and Asia Pacific (Singapore)",
    regions: ["ap-northeast-1", "ap-southeast-1"],
    enabled: false,
    status: "Coming Soon"
  },
  in: {
    label: "IN - Asia Pacific (Mumbai) and Asia Pacific (Hyderabad)",
    regions: ["ap-south-1", "ap-south-2"],
    enabled: false,
    status: "Coming Soon"
  }
};
var AWS_REGION_ALIASES = {
  pdx: "us-west-2",
  iad: "us-east-1",
  fra: "eu-central-1",
  dub: "eu-west-1",
  tyo: "ap-northeast-1",
  sin: "ap-southeast-1",
  bom: "ap-south-1",
  hyd: "ap-south-2"
};
var CONTINENT_SHORT_LABEL = {
  us: "US",
  eu: "EU",
  ap: "APAC",
  in: "India"
};
var CONTINENT_FLAG = {
  us: "\u{1F1FA}\u{1F1F8}",
  eu: "\u{1F1EA}\u{1F1FA}",
  ap: "\u{1F30F}",
  in: "\u{1F1EE}\u{1F1F3}"
};
function regionOrThrow(region) {
  const info = AWS_REGIONS[region];
  if (!info) throw new Error(`Invalid region: ${region}`);
  return info;
}
function convertRegionToContinent(region) {
  return regionOrThrow(region).continent;
}
function continentForRegionOrAlias(value) {
  if (value in AWS_CONTINENTS) return value;
  const region = value in AWS_REGIONS ? value : AWS_REGION_ALIASES[value];
  return region ? AWS_REGIONS[region]?.continent : void 0;
}
function convertRegionToBackupRegion(region) {
  return regionOrThrow(region).backupRegion;
}
function convertRegionToAlias(region) {
  return regionOrThrow(region).alias;
}
function getAvailableContinents() {
  const out = {};
  for (const [continent, info] of Object.entries(AWS_CONTINENTS)) {
    out[continent] = { ...info };
  }
  return out;
}
function getRegionInfo(region) {
  return regionOrThrow(region);
}
function getEnabledRegions() {
  return Object.entries(AWS_REGIONS).filter(([, info]) => info.enabled).map(([region]) => region);
}
function getRegionsByContinent(continent) {
  const info = AWS_CONTINENTS[continent];
  if (!info) throw new Error(`Invalid continent: ${continent}`);
  return info.regions;
}
function isRegionEnabled(region) {
  return regionOrThrow(region).enabled;
}
function validateRegionPair(primary, backup) {
  return regionOrThrow(primary).backupRegion === backup;
}

export { AWS_CONTINENTS, AWS_REGIONS, AWS_REGION_ALIASES, CONTINENT_FLAG, CONTINENT_SHORT_LABEL, continentForRegionOrAlias, convertRegionToAlias, convertRegionToBackupRegion, convertRegionToContinent, getAvailableContinents, getEnabledRegions, getRegionInfo, getRegionsByContinent, isRegionEnabled, validateRegionPair };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map